import { render, staticRenderFns } from "./ReporteBoletos.vue?vue&type=template&id=2421264c&"
import script from "./ReporteBoletos.vue?vue&type=script&lang=js&"
export * from "./ReporteBoletos.vue?vue&type=script&lang=js&"
import style0 from "./ReporteBoletos.vue?vue&type=style&index=0&id=2421264c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports